import { render, staticRenderFns } from "./AntecedentesPatologicos.vue?vue&type=template&id=35977f64&"
import script from "./AntecedentesPatologicos.vue?vue&type=script&lang=js&"
export * from "./AntecedentesPatologicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports